<body class="hold-transition login-page" style="background-color: red;">
<div class="login-box">
   
    <!-- /.login-logo -->
    <div class="card card-outline card-danger">
      <div class="card-header text-center">
       <img src="assets/dist/img/champ.gif" class="champlogo" alt="champlogo" >
      </div>
      <div class="card-body">
        <p class="login-box-msg"><b>Sign-In</b> </p>
  
        <form #f="ngForm" id="sign_in" method="POST" name="form">
          <div class="input-group mb-3">
            <input type="text" class="form-control" name="scode" [(ngModel)]="user.scode" placeholder="Institution Code">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-graduation-cap"></span>
              </div>
            </div>
          </div>
          <div class="input-group mb-3">
            <input type="email" class="form-control" name="username"  [(ngModel)]="user.username" placeholder="UserName">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-envelope"></span>
              </div>
            </div>
          </div>
          <div class="input-group mb-3">
            <input type="password" class="form-control" name="password"  [(ngModel)]="user.password" placeholder="Password">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-lock"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-8">
              <div class="icheck-primary">
                <input type="checkbox" id="remember">
                <label for="remember">
                  Remember Me
                </label>
              </div>
            </div>
            <!-- /.col -->
            <div class="col-4">
              <button type="submit" class="btn btn-danger btn-block" (click)="login()">Sign In</button>
            </div>
            <!-- /.col -->
          </div>
        </form>
  
       
        <!-- /.social-auth-links -->
  
        <!-- <p class="mb-1">
          <a href="forgot-password.html">I forgot my password</a>
        </p>
        <p class="mb-0">
          <a href="register.html" class="text-center">Register a new membership</a>
        </p> -->
      </div>
      <!-- /.card-body -->
    </div>
  </div>


</body>
  <!-- /.login-box -->